document.addEventListener('DOMContentLoaded', () => {
  const WRAP_STD_HANDLE = 'envoltorio-regalo'; 
  const cbStd = document.querySelector('#gift-wrap-checkbox');
  if (!cbStd) return;

  let wrapStdVariantId = null;

  // 1. Carga del ID de variante (Mantenemos tu lógica)
  fetch(`/products/${WRAP_STD_HANDLE}.js`)
    .then(r => r.json())
    .then(prod => {
      wrapStdVariantId = prod?.variants?.[0]?.id || null;
    })
    .catch(e => console.error(`Error obteniendo el envoltorio:`, e));

  // 2. Mejora en la detección de cantidad para Horizon
  const getTargetQty = () => {
    // Horizon suele usar selectores específicos. Buscamos el input de cantidad más cercano al checkbox
    const qtyInput = document.querySelector('input[name="quantity"]') || document.querySelector('.quantity__input');
    const q = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    return (Number.isFinite(q) && q > 0) ? q : 1;
  };

  const originalFetch = window.fetch;
  window.fetch = async function(...args) {
    let [resource, config] = args;

    if (resource && typeof resource === 'string' && resource.includes('/cart/add')) {
      
      // SOLO actuamos si el checkbox está marcado Y tenemos el ID del envoltorio
      if (cbStd.checked && wrapStdVariantId && !resource.includes('gift_wrap_added=1')) {
        try {
          const qty = getTargetQty();
          let items = [];

          if (config && config.body) {
            // Caso A: El tema envía FormData
            if (config.body instanceof FormData) {
              const newFormData = new FormData();
              let mainProductId = '';
              
              for (let [key, value] of config.body.entries()) {
                if (key === 'id') mainProductId = value;
                newFormData.append(key, value);
              }
              
              // Aquí está la magia: añadimos el envoltorio como segundo ítem
              // Usamos la API de /cart/add.js que acepta múltiples ítems vía JSON
              const jsonBody = {
                items: [
                  { id: mainProductId, quantity: qty },
                  { id: wrapStdVariantId, quantity: qty }
                ]
              };

              config.body = JSON.stringify(jsonBody);
              config.headers = { 
                ...config.headers, 
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest' 
              };

            // Caso B: El tema envía JSON (Horizon suele hacer esto)
            } else if (typeof config.body === 'string') {
              const parsed = JSON.parse(config.body);
              let mainItems = parsed.items ? parsed.items : [parsed];
              
              // Añadimos el envoltorio a la lista de ítems
              mainItems.push({ id: wrapStdVariantId, quantity: qty });
              
              config.body = JSON.stringify({ items: mainItems });
            }
          }

          // Prevenimos bucles infinitos
          args[0] = resource + (resource.includes('?') ? '&' : '?') + 'gift_wrap_added=1';

        } catch (e) {
          console.error("Error al agrupar el papel de regalo:", e);
        }
      }
    }

    return originalFetch.apply(this, args);
  };
});